// SummaryCard.jsx
import React from 'react';
import i18n from '../../i18n';
import { SaudiRiyalIcon } from 'lucide-react';

class SummaryCard extends React.Component {
  render() {
    const { icon: Icon, label, amount, className, onClick } = this.props;

    return (
      <div
        className={`summary-card ${className} ${onClick ? 'summary-card-interactive' : ''}`}
        onClick={onClick}
        style={onClick ? { cursor: 'pointer' } : {}}
      >
        <div className="card-icon">
          <Icon size={24} />
        </div>
        <div className="card-content">
          <p className="card-label">{label}</p>
          <p className="card-amount">
            {amount}
            <span className="currency"><SaudiRiyalIcon/> </span>
          </p>
        </div>
      </div>
    );
  }
}

export default SummaryCard;
